<template>
  <svg
    :id="id"
    :width="width ?? size"
    :height="height ?? size"
    :viewBox="`0 0 ${width ?? size} ${height ?? size}`"
    :class="['shrink-0', className]"
    preserveAspectRatio="xMidYMid meet"
    xmlns="http://www.w3.org/2000/svg"
    :data-testid="dataTestid">
    <use
      :data-testid="`${dataTestid}__href`"
      :href="spriteHref"/>
  </svg>
</template>

<script setup lang="ts" generic="T extends IconType = 'core'">
import { computed } from 'vue';

import spriteCore from '@/_redesign/shared/sprite/core.svg';
import spriteCountry from '@/_redesign/shared/sprite/country.svg';
import spriteSized from '@/_redesign/shared/sprite/sized.svg';
import { IconProps } from '@/_redesign/shared/types/IconProps';
import { IconType } from '@/_redesign/shared/types/IconType';

const {
  type = 'core',
  size = 24,
  name,
  width,
  height,
  class: className,
  dataTestid,
} = defineProps<IconProps>();

const spriteByType: Record<IconType, string> = {
  country: spriteCountry,
  sized: spriteSized,
  core: spriteCore,
};

const spriteHref = computed(() => (
  name ? [spriteByType[type], name].join('#') : ''
));
</script>
